import { Button } from "antd";
import styled from "styled-components";

export const DocumentPageWrapper = styled.div`
  padding: 24px;
  width: 100%;
  height: calc(100vh - 80px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const ToolbarRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  flex-shrink: 0;
  gap: 12px;
`;

export const ContentArea = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  gap: 16px;
`;

export const TablePanel = styled.div`
  flex-shrink: 0;
  max-height: 220px;
  overflow-y: auto;
`;

export const PdfViewerContainer = styled.div`
  flex: 1;
  min-height: 0;
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;

  iframe {
    border: none;
  }
`;

export const IconAddDocument = styled.img`
  width: 1.5rem;
  height: 2.03rem;
  cursor: pointer;
  border-radius: 2px;
  margin-left: 0.5rem;
`;

export const NothingContent = styled.div`
  text-align: center;
  margin-top: 100px;
  font-size: 24px;
  color: #999;
`;

export const ButtonDownLoadWrapper = styled.div`
  border: none;
  color: white;
  border-radius: 4px;
  display: flex;
  align-items: center;
  padding: 6px 10px;
  cursor: ${(props) => (props?.disabled ? "no-drop" : "pointer")} !important;
  font-weight: bold;
  background-color: #0089cf;
  img {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }
`;

export const SelectWrapper = styled.div`
  width: 100%;
  height: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  div {
    width: 80%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  img {
    width: 20px;
    height: 20px;
  }
`;

export const SelectWrapperDoc = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
`;

export const CreatefromWrapper = styled.div`
  width: 100%;
  max-width: 800px;
`;

export const ButtonCustom = styled(Button)`
  margin-right: 12px;
`;

export const ButtonDownload = styled.div`
  border-radius: 4px;
  margin-right: 20px;
  display: flex;
  align-items: center;
  padding: 6px 10px;
  cursor: pointer;
  font-weight: 500;
  img {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }
  :hover {
    color: green;
    cursor: pointer;
  }
`;
